/**
 * @fileoverview added by tsickle
 * Generated from: providers/api-url-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { INFRA_CONFIG_TOKEN, InfraConfig } from './config';
import { Inject, Injectable } from '@angular/core';
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './config';
var ABSOLUTE_URL_REGEX = /^https?:/;
/**
 * A service to provide normalised API urls, by appending the API root to
 * any relative url.
 */
var ApiUrlService = /** @class */ (function () {
    function ApiUrlService(config) {
        this.config = config;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    ApiUrlService.prototype.normaliseUrl = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (url.indexOf('/') === 0 || ABSOLUTE_URL_REGEX.test(url)) {
            return url;
        }
        else {
            return "" + this.config.API_ROOT + url;
        }
    };
    /** @nocollapse */
    ApiUrlService.ctorParameters = function () { return [
        { type: InfraConfig, decorators: [{ type: Inject, args: [INFRA_CONFIG_TOKEN,] }] }
    ]; };
ApiUrlService.ɵfac = function ApiUrlService_Factory(t) { return new (t || ApiUrlService)(ɵngcc0.ɵɵinject(INFRA_CONFIG_TOKEN)); };
ApiUrlService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ApiUrlService, factory: function (t) { return ApiUrlService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApiUrlService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.InfraConfig, decorators: [{
                type: Inject,
                args: [INFRA_CONFIG_TOKEN]
            }] }]; }, null); })();
    return ApiUrlService;
}());
export { ApiUrlService };
if (false) {
    /** @type {?} */
    ApiUrlService.prototype.config;
}

